import React from 'react';

const Loading: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-brand-blue flex items-center justify-center z-50">
      <div className="text-center">
        <div className="w-16 h-16 mx-auto mb-6">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-white"></div>
        </div>
        <div className="text-white text-xl font-semibold">Loading...</div>
      </div>
    </div>
  );
};

export default Loading;
